// 配置菜单列表
// hiddenInNav: true 时侧栏不展示该项，配置与路由仍保留
const menuList = [
  {
    title: '首页',
    key: '/home',
    icon: 'home',
  },
  {
    title: '用户列表',
    key: '/user',
    icon: 'user',
    children: [
      {
        title: '分销人员',
        key: '/user/salesman',
        icon: 'usergroup-add'
      }, 
      {
        title: '用户列表',
        key: '/user/list',
        icon: 'usergroup-add'
      },
      {
        title: '员工列表',
        key: '/user/internal',
        icon: 'usergroup-add',
        hiddenInNav: true,
      }
    ]
  },
  {
    title: '商品管理',
    key: '/goods',
    icon: 'shopping',
    children: [
      {
        title: '商品列表',
        key: '/goods/list',
        icon: 'profile'
      },
      {
        title: '商品分类管理',
        key: '/goods/type',
        icon: 'apartment'
      },
      {
        title: '商品视频管理',
        key: '/goods/video',
        icon: 'reconciliation',
        hiddenInNav: true,
      },
    ]
  },
  {
    title: '商城推荐',
    key: '/recommended',
    icon: 'shopping',
    hiddenInNav: true,
    children: [
      {
        title: '新鲜好物',
        key: '/recommended/freshGoods',
        icon: 'profile'
      },
      {
        title: '汽运推荐',
        key: '/recommended/trucks',
        icon: 'apartment'
      },
      {
        title: '秒杀活动',
        key: '/recommended/flashGood',
        icon: 'apartment'
      },
    ]
  },
  {
    title: '订单管理',
    key: '/order',
    icon: 'file-done',
    children: [
      {
        title: '商品订单列表',
        key: '/order/list',
        icon: 'profile'
      },
      {
        key: '/order/returnform',
        title: '退货订单',
        icon: 'profile'
      },
      {
        key: '/order/returnReason',
        title: '退货原因设置',
        icon: 'profile'
      },
      {
        key: '/order/touristes',
        title: '旅游专线统计',
        icon: 'profile',
        hiddenInNav: true,
      },
      {
        key: '/order/healthOrder/statistics',
        title: '健康专线统计',
        icon: 'profile',
        hiddenInNav: true,
      },
      {
        key: '/order/healthOrder/foreign',
        title: '第三方健康专线订单',
        icon: 'profile',
        hiddenInNav: true,
      },
      {
        key: '/order/charteredBus/list',
        title: '包车订单',
        icon: 'profile',
        hiddenInNav: true,
      },
    ]
  },
  {
    title: '出行管理',
    key: '/trip',
    icon: 'car',
    hiddenInNav: true,
    children: [
      {
        title: '旅游专线列表',
        key: '/trip/travelList',
        icon: 'flag'
      },
      {
        title: '健康专线列表',
        key: '/trip/healthList',
        icon: 'heart'
      },
      {
        title: '真惠玩',
        key: '/trip/travelNewList',
        icon: 'flag'
      },
    ]
  },
  {
    title: '财务管理',
    key: '/finance',
    icon: 'file-done',
    children: [
      {
        title: '平台统计',
        key: '/finance/platform',
        icon: 'notification'
      },
      {
        title: '分销统计',
        key: '/finance/salesStatistic',
        icon: 'money-collect'
      },
      {
        title: '提现申请',
        key: '/finance/withdrawal',
        icon: 'pushpin'
      },
      {
        title: '商家充值记录',
        key: '/finance/recharge/log',
        icon: 'block',
      },
      {
        title: '积分派送记录',
        key: '/finance/barRecord',
        icon: 'block',
      },
    ]
  },
  {
    title: '商户管理',
    key: '/system',
    icon: 'file-done',
    children: [
      {
        title: '添加商户',
        key: '/system/merchant/add',
        icon: 'profile'
      },
      {
        title: '商户列表',
        key: '/system/merchant/list',
        icon: 'profile'
      },
      {
        title: '商户类型',
        key: '/system/merchant/types',
        icon: 'profile'
      },
    ]
  },
  {
    title: '终端管理',
    key: '/appManager',
    icon: 'file-done',
    children: [
      {
        title: '购票订单',
        key: '/app/order',
        icon: 'notification',
        hiddenInNav: true,
      },
      {
        title: '商城广告',
        key: '/app/advert',
        icon: 'notification'
      },
      {
        title: '优惠券',
        key: '/discount/list',
        icon: 'account-book',
        hiddenInNav: true,
      },
      {
        title: '优惠券设置',
        key: '/couponSetting/couponSetting',
        icon: 'account-book',
        hiddenInNav: true,
      },
      {
        title: '每日签到设置',
        key: '/signBoard/signBoard',
        icon: 'check-square',
        hiddenInNav: true,
      },
      {
        title: '签到列表',
        key: '/signBoard/signList',
        icon: 'check',
        hiddenInNav: true,
      },
      {
        title: '专题管理',
        key: '/appManager/specil',
        icon: 'profile',
        hiddenInNav: true,
      },
      {
        title: '兴趣目录',
        key: '/taste',
        icon: 'block',
        hiddenInNav: true,
      },
      {
        title: '版本管理',
        key: '/app/versions',
        icon: 'paper-clip',
        hiddenInNav: true,
      },
      {
        title: 'APP推送',
        key: '/app/push',
        icon: 'pushpin',
        hiddenInNav: true,
      },
      {
        title: '系统消息',
        key: '/app/message',
        icon: 'message',
        hiddenInNav: true,
      },
      {
        title: '反馈意见',
        key: '/app/feedback',
        icon: 'form',
      },
      // {
      //   title: 'APP设置',
      //   key: '/app/setting',
      //   icon: 'setting',
      // },
    ]
  },
  {
    title: '学生认证',
    key: '/certification',
    icon: 'setting',
    hiddenInNav: true,
    children: [{
      title: '学生认证',
      key: '/certification/student',
      icon: 'solution'
    }]
  },
  {
    title: '系统管理',
    key: '/admin',
    icon: 'setting',
    children: [{
      title: '管理员列表',
      key: '/admin/list',
      icon: 'solution'
    }, {
      title: '微信支付商户',
      key: '/admin/wxPayMch',
      icon: 'pay-circle'
    }, {
      title: '小程序支付绑定',
      key: '/admin/wxMiniappPayBind',
      icon: 'link'
    }] 
  }
  
]

export default menuList